import CommonService from "../../services/commonService";
import LabourPlanningService from "../../services/labourPalnningService";
import CommonUtils from "../../utils/common.utils";
import moment from "moment";
import axios from "axios";

const state = {
	scheduler_view: 'weekly',
	scheduler_month: null,
	table_loader: true,
	month_scheduler_employee_data: [],
	month_scheduler_shift_data: [],
	month_scheduler_shift_ass_data: [],
	all_store_list: [],
	all_emp_leaves_data: [],
	secondary_stores: [],
};

const mutations = {
	SET_SCHEDULER_VIEW(state, view){
		state.scheduler_view = view;
	},
	SET_SCHEDULER_MONTH(state, month){
		state.scheduler_month = month;
	},
	SET_MONTH_SCHEDULER_EMP_DATA(state, data){
		state.month_scheduler_employee_data = data;
		const storeIds = [];
		data.forEach(e => {
			e.secondary_stores.forEach( l => storeIds.push(l))
		});
		const uniqueData = storeIds.filter(
			(obj, index, self) =>
				index ===
				self.findIndex(
				(t) => t.id === obj.id && t.name === obj.name
				)
		);
		console.log(uniqueData, 'uniqueData');
    	state.secondary_stores = uniqueData;
	},
	SET_MONTH_SCHEDULER_SHIFT_DATA(state, data){
		state.month_scheduler_shift_data = data;
	},
	SET_MONTH_SCHEDULER_SHIFT_ASS_DATA(state, data){
		state.month_scheduler_shift_ass_data = data;
	},
	SET_STORE_LIST_DATA(state, data){
		state.all_store_list = data;
	},
	SET_TABLE_LOADER_STATE(state, condition){
		state.table_loader = condition;
	},
	SET_MONTH_SCHEDULER_EMP_LEAVES_DATA(state, data){
		state.all_emp_leaves_data = data;
	},
};

const actions = {
	// getEmpDayWiseDataAction({commit}, payload){
	// 	let getEmpPayload = { outlet_id: payload.storeID, start_date: payload.formDate, end_date: payload.toDate}
	// 	let getEmpLeavesParams = { store_id: payload.storeID, start_date: payload.formDate, end_date: payload.toDate, get_all: true}
	// 	commit('SET_TABLE_LOADER_STATE', true)
		
	// 	LabourPlanningService.getMonthlySchedulerData(
	// 		getEmpPayload,
	// 		getEmpPayload,
	// 		getEmpPayload,
	// 		getEmpLeavesParams
	// 	).then(axios.spread((
	// 		getEmpDataRes,
	// 		getShiftDataRes,
	// 		getShiftWiseAssDataRes,
	// 		getLeavesDataRes
	// 	)=>{
	// 		if( getEmpDataRes.status == 200 &&
	// 			getShiftDataRes.status == 200 &&
	// 			getShiftWiseAssDataRes.status == 200 &&
	// 			getLeavesDataRes.status
	// 		) {
	// 			commit('SET_TABLE_LOADER_STATE', false)
	// 			let getEmpData = JSON.parse(getEmpDataRes.data);
	// 			let getShiftData = JSON.parse(getShiftDataRes.data);
	// 			let getShiftWiseAssData = JSON.parse(getShiftWiseAssDataRes.data);
	// 			let getLeavesData = JSON.parse(getLeavesDataRes.data);
	// 			commit('SET_MONTH_SCHEDULER_EMP_DATA', getEmpData)
	// 			commit('SET_MONTH_SCHEDULER_SHIFT_DATA', getShiftData)
	// 			commit('SET_MONTH_SCHEDULER_SHIFT_ASS_DATA', getShiftWiseAssData)
	// 			commit('SET_MONTH_SCHEDULER_EMP_LEAVES_DATA', getLeavesData)
	// 		}
	// 	})).catch((err)=>{
	// 		commit('SET_TABLE_LOADER_STATE', false)
	// 		console.error(err);
	// 		commit('SET_MONTH_SCHEDULER_EMP_DATA', [])
	// 		commit('SET_MONTH_SCHEDULER_SHIFT_DATA', [])
	// 		commit('SET_MONTH_SCHEDULER_SHIFT_ASS_DATA', [])
	// 		commit('SET_MONTH_SCHEDULER_EMP_LEAVES_DATA', [])
	// 	});
	// },
	// getUpdatedShiftDataAction({commit}, payload){
	// 	let getEmpPayload = { outlet_id: payload.storeID, start_date: payload.formDate, end_date: payload.toDate, get_all: true};
	// 	// Before call empty data  
	// 	LabourPlanningService.getUpdatedShiftData(
	// 		getEmpPayload,
	// 		getEmpPayload
	// 	).then(axios.spread((
	// 		getShiftDataRes,
	// 		getShiftWiseAssDataRes
	// 	)=>{
	// 		if( getShiftDataRes.status == 200 &&
	// 			getShiftDataRes.status == 200
	// 		) {
	// 			let getShiftData = JSON.parse(getShiftDataRes.data);
	// 			let getShiftWiseAssData = JSON.parse(getShiftWiseAssDataRes.data);
	// 			commit('SET_MONTH_SCHEDULER_SHIFT_DATA', getShiftData);
	// 			commit('SET_MONTH_SCHEDULER_SHIFT_ASS_DATA', getShiftWiseAssData);
	// 		}
	// 	})).catch((err)=>{
	// 		console.error(err);
	// 	});
	// },
	getStoreDataAction({commit}){
		LabourPlanningService.getAllStoreData().then((res)=>{
			let data = JSON.parse(res.data);
			commit('SET_STORE_LIST_DATA', data)
			// state.month_scheduler_data = JSON.parse(JSON.stringify(data));
		}).catch((err)=>{
			console.error(err)
		});
	},
};

export default {
	state,
	mutations,
	actions,
	namespaced: true
};